/* eslint-disable import/prefer-default-export */
import {
  backgroundColorWhite,
  colorBlack,
  colorBlue,
  colorGray,
  focusedColor,
  font
} from "../../styleConstants";

export const filtersStyles = {
  container: provided => ({ ...provided, order: 2, maxHeight: "22px" }),
  control: provided => ({
    ...provided,
    borderRadius: "2px",
    border: "none",
    backgroundColor: "unset",
    boxShadow: "none",
    minHeight: "20px",
    height: "20px"
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "4px 8px",
    fontFamily: font,
    fontSize: "16px",
    lineHeight: "120%",
    fontStyle: "normal",
    fontWeight: "300",
    color: state.isSelected ? colorBlue : colorBlack,
    maxHeight: "34px",
    backgroundColor: state.isFocused ? focusedColor : "none"
  }),
  placeholder: provided => ({
    ...provided,
    fontFamily: font,
    fontSize: "16px",
    lineHeight: "120%",
    fontStyle: "normal",
    fontWeight: 300,
    maxHeight: "20px",
    color: colorGray
  }),
  singleValue: (provided, state) => ({
    ...provided,
    opacity: state.isDisabled ? 0.5 : 1,
    transition: "opacity 300ms",
    fontFamily: font,
    fontSize: "16px",
    lineHeight: "120%",
    fontStyle: "normal",
    fontWeight: 300,
    minHeight: "20px",
    height: "20px",
    paddingTop: "1px",
    color: colorBlue
  }),
  input: provided => ({
    ...provided
  }),
  valueContainer: () => ({}),
  menu: provided => ({
    ...provided,
    border: "none",
    width: "125%"
  })
};

export const audienceFiltersStyles = {
  container: provided => ({
    ...provided,
    order: 2,
    // height: "48px",
    height: "40px !important",
    transition: "all .25s ease, .25s opacity .12s ease",
    width: "100%",
    maxWidth: "100%",
    opacity: 1,
    paddingLeft: "15px",
    paddingRight: "8px",
    backgroundColor: backgroundColorWhite,
    cursor: "pointer"
  }),
  control: provided => ({
    ...provided,
    border: "none",
    backgroundColor: "unset",
    boxShadow: "none",
    minHeight: "100%",
    height: "100%",
    cursor: "pointer"
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "4px 8px",
    fontFamily: font,
    fontSize: "16px",
    lineHeight: "120%",
    fontStyle: "normal",
    fontWeight: "300",
    color: state.isSelected ? colorBlue : colorBlack,
    maxHeight: "34px",
    backgroundColor: state.isFocused ? focusedColor : "none",
    cursor: "pointer"
  }),
  placeholder: provided => ({
    ...provided,
    fontFamily: font,
    fontSize: "16px",
    lineHeight: "120%",
    fontStyle: "normal",
    fontWeight: 400,
    maxHeight: "20px",
    color: colorBlack,
    cursor: "pointer"
  }),
  singleValue: (provided, state) => ({
    ...provided,
    opacity: state.isDisabled ? 0.5 : 1,
    transition: "opacity 300ms",
    fontFamily: font,
    fontSize: "15px",
    lineHeight: "120%",
    fontStyle: "normal",
    fontWeight: 400,
    minHeight: "20px",
    height: "20px",
    paddingTop: "1px",
    color: colorBlue,
    cursor: "pointer"
  }),
  input: provided => ({
    ...provided,
    cursor: "pointer"
  }),
  valueContainer: () => ({}),
  menu: provided => {
    return {
      ...provided,
      border: "none",
      // width: "125%",
      cursor: "pointer"
    };
  }
};
